import { useState } from 'react';

import { CheckIcon } from '@phosphor-icons/react/dist/ssr';

import type { Price } from '@/types';

import { ButtonElement } from '../buttonElement/ButtonElement';
import { TabsElement } from '../tabsElement/TabsElement';
import type { TierCardElementProps } from './TierCardElement.types';

const TierCardElement = ({
  tier,
  disableActions,
  translations,
  subscribedToPriceIds = [],
  onSelectPrice,
}: TierCardElementProps) => {
  const [selectedPrice, setSelectedPrice] = useState(tier.prices[0]);

  const handleClickPriceTab = (price: Price) => () => setSelectedPrice(price);

  return (
    <div className="sm:min-w-64 flex flex-col w-full border border-gray-200 rounded-xl overflow-hidden bg-white p-4">
      <div className="flex items-center justify-between py-4">
        <span className="text-lg font-semibold text-gray-900">{tier.name}</span>
        <span className="text-xl font-semibold text-gray-900">{selectedPrice.formatted_amount}</span>
      </div>
      {tier.prices.length > 1 && (
        <TabsElement
          tabs={tier.prices.map((price) => ({
            key: price.id,
            label: price.denominator || price.interval.split('_').join(' '),
            selected: price.id === selectedPrice?.id,
            onClick: handleClickPriceTab(price),
          }))}
        />
      )}
      <div className="flex flex-col flex-1 py-4 bg-white">
        <div className="mb-6 space-y-4">
          {Array.isArray(selectedPrice.features) &&
            selectedPrice.features.map((feature) => (
              <div key={feature} className="flex items-start gap-2 text-gray-700 text-base">
                <CheckIcon className="w-4 h-4 mt-1 text-gray-700" />
                <p className="text-sm">{feature}</p>
              </div>
            ))}
        </div>
        {subscribedToPriceIds.includes(selectedPrice.id) ? (
          <ButtonElement disabled variant="primary" className="w-full mt-auto">
            {translations?.['billing.plans_modal.current_plan_button']}
          </ButtonElement>
        ) : onSelectPrice ? (
          <ButtonElement
            disabled={disableActions}
            type="button"
            variant="primary"
            className="w-full mt-auto"
            onClick={() => onSelectPrice(selectedPrice.id)}
          >
            {translations?.['billing.plans_modal.switch_to_plan_button']}
          </ButtonElement>
        ) : (
          <>
            {selectedPrice.id && <input type="hidden" name="price_id" value={selectedPrice.id} />}
            <ButtonElement disabled={disableActions} type="submit" variant="primary" className="w-full mt-auto">
              {translations?.['billing.plans_modal.switch_to_plan_button']}
            </ButtonElement>
          </>
        )}
      </div>
    </div>
  );
};

export { TierCardElement };
